import { render } from "./BlogGridPage.vue?vue&type=template&id=7790df25"
import script from "./BlogGridPage.vue?vue&type=script&lang=js"
export * from "./BlogGridPage.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__